// extracted by mini-css-extract-plugin
export default {"section":"Header_section__9n7Ga","container":"Header_container__M4+4Z","overlay":"Header_overlay__5OFWd","bar":"Header_bar__UXxl4"};